"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMacro = exports.expandMacro = void 0;
const constants_1 = require("../constants");
const errors_1 = require("../errors/errors");
const listHelpers_1 = require("../utils/listHelpers");
const interpreter_1 = require("./interpreter");
const procedure_1 = require("./procedure");
const util_1 = require("./util");
const value_1 = require("./value");
function* expandMacro(context, macro, suppliedArgs, node) {
    procedure_1.checkNumberOfArguments(context, macro.name, macro.callSignature, suppliedArgs.length, node);
    const environment = procedure_1.extendEnvironmentWithNewBindings(context, macro.environment, macro.name, procedure_1.matchArgumentsToParameters(macro.callSignature, suppliedArgs));
    util_1.pushEnvironment(context, environment);
    let result;
    for (let i = 0; i < macro.body.length; i++) {
        const expression = macro.body[i];
        result = yield* interpreter_1.evaluate(expression, context);
    }
    util_1.popEnvironment(context);
    return result;
}
exports.expandMacro = expandMacro;
/**
 * Expands the given macro using the given arguments and evaluate the expanded form.
 */
function* useMacro(context, macro, suppliedArgs, node) {
    // Convert the syntax forms to expressible values for use in the macro body
    const suppliedSExpressions = suppliedArgs.map(syntaxToExpressibleValue);
    const expandedSExpression = yield* expandMacro(context, macro, suppliedSExpressions, node);
    let expandedSyntax;
    try {
        expandedSyntax = expressibleValueToSyntax(expandedSExpression);
    }
    catch (e) {
        return util_1.handleRuntimeError(context, new errors_1.MacroExpansionError(e, node));
    }
    // Must pass down the tail context of the macro use site
    procedure_1.tryEnterTailContext(context);
    return yield* interpreter_1.evaluate(expandedSyntax, context);
}
exports.useMacro = useMacro;
const syntaxToExpressibleValue = (syntax) => {
    switch (syntax.type) {
        case 'boolean':
        case 'number':
        case 'string':
        case 'symbol':
            return Object.assign({}, syntax);
        case 'dotted list':
            return value_1.makeImproperList(syntax.pre.map(syntaxToExpressibleValue), syntaxToExpressibleValue(syntax.post), syntax.loc);
        case 'list':
            return value_1.makeList(syntax.elements.map(syntaxToExpressibleValue), syntax.loc);
    }
};
const expressibleValueToSyntax = (value) => {
    var _a, _b, _c;
    switch (value.type) {
        case 'boolean':
        case 'number':
        case 'string':
        case 'symbol':
            return value;
        case 'pair':
            const list = listHelpers_1.flattenPairToList(value);
            if (list.type === 'List') {
                return {
                    type: 'list',
                    elements: list.value.map(element => expressibleValueToSyntax(element.value)),
                    loc: (_a = value.loc) !== null && _a !== void 0 ? _a : constants_1.UNKNOWN_LOCATION
                };
            }
            else {
                return {
                    type: 'dotted list',
                    pre: [
                        ...list.value.properPart.map(element => element.value),
                        list.value.lastPair.head
                    ].map(element => expressibleValueToSyntax(element)),
                    post: expressibleValueToSyntax(list.value.lastPair.tail),
                    loc: (_b = value.loc) !== null && _b !== void 0 ? _b : constants_1.UNKNOWN_LOCATION
                };
            }
        case 'empty list':
            return {
                type: 'list',
                elements: [],
                loc: (_c = value.loc) !== null && _c !== void 0 ? _c : constants_1.UNKNOWN_LOCATION
            };
        case 'macro':
        case 'procedure':
        case 'TailCall':
            throw value;
    }
};
//# sourceMappingURL=macro.js.map